import { AcademyMath } from '../academy/AcademyMath';
import { AcademyRichText } from '../academy/AcademyRichText';
import type { TutorReply } from './tutorChat';
import { StudyContextTools } from './StudyContextTools.tsx';
export function TutorMessage({
  reply,
  subjectKey,
  contextDisabled = false,
  returnTo,
  sourceVersion,
}: {
  reply: TutorReply;
  subjectKey?: string;
  contextDisabled?: boolean;
  returnTo?: string;
  sourceVersion?: number;
}) {
  return (
    <div className="space-y-3 text-sm leading-relaxed">
      {reply.blocks.map((block, index) =>
        block.type === 'text' ? (
          <p key={index} className="whitespace-pre-wrap break-words">
            <AcademyRichText text={block.text} />
          </p>
        ) : block.type === 'math' ? (
          <div
            key={index}
            className="max-w-full overflow-x-auto"
            tabIndex={0}
            aria-label="Tutor formula"
          >
            <AcademyMath latex={block.latex} display={block.display} />
          </div>
        ) : (
          <div
            key={index}
            className="max-w-full overflow-x-auto"
            tabIndex={0}
            aria-label="Tutor data table"
          >
            <table className="w-full border-collapse text-left">
              <thead>
                <tr>
                  {block.headers.map((cell, j) => (
                    <th key={j} className="border border-hairline p-2">
                      <AcademyRichText text={cell} />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {block.rows.map((row, i) => (
                  <tr key={i}>
                    {row.map((cell, j) => (
                      <td key={j} className="border border-hairline p-2">
                        <AcademyRichText text={cell} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ),
      )}
      {subjectKey && (
        <StudyContextTools
          compact
          disabled={contextDisabled}
          context={{
            subjectKey,
            returnTo,
            sourceVersion,
            label: 'This explanation',
            text: reply.blocks
              .flatMap((block) => (block.type === 'text' ? [block.text] : []))
              .join('\n'),
          }}
        />
      )}
    </div>
  );
}
